import "../../App.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footerContracts">
        <div className="footerBlock">
          <a
            href="https://snowtrace.io/token/0x76938525d4ED7D0b22a899d8bDc1bEF57cd47D18?chainid=43114"
            target="_blank"
            rel="noreferrer"
          >
            <h5>G-ETTO on Avalanche</h5>
          </a>

          <p>0x76938525d4ED7D0b22a899d8bDc1bEF57cd47D18</p>
        </div>

        <div className="footerBlock">
          <a
            href="https://basescan.org/token/0xc45d82628E0698404271B3C9Cb6DC2d77efd9346"
            target="_blank"
            rel="noreferrer"
          >
            <h5>G-ETTO on Base</h5>
          </a>

          <p>0xc45d82628E0698404271B3C9Cb6DC2d77efd9346</p>
        </div>
      </div>

      <div className="footerCopyright">
        <p>Copyright © 2026 Garetto G-ETTO. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
